


























































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {PodesavanjeSistema, StavkaDokumenta} from "@/services/BackendProxies";
import {formatPrice} from "@/utils/formatters";
import {focusCena} from "@/utils/focusFunctions";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {State} from "vuex-class";

@Component({})
export default class StavkeFaktureBezRadnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop() stavke!: StavkaDokumenta[];
    @State podesavanjeSistema: PodesavanjeSistema;

    dodajStavku(row, field) {
        this.stavke.push(StavkaDokumenta.fromJS({iznos: 0, pdvStopa: this.podesavanjeSistema.pdvStopa}));
    }

    obrisiStavku(stavka: StavkaDokumenta) {
        this.obrisanaStavka(stavka);
    }

    @Emit() obrisanaStavka(stavke: StavkaDokumenta) {}

    @Watch('stavke', {deep: true}) onServisnaOperacijaChanged(value: StavkaDokumenta[]) {
        value.forEach(s => {
            s.osnovica = (s.kolicina * s.cena) * (1 - (s.rabat || 0) / 100);
            s.pdv = s.osnovica * s.pdvStopa / 100;
            s.iznos = s.osnovica + s.pdv;
        });
    }

    fokusirajCeliju(dataCellValue) {
        this.$nextTick(() => {
            $(`[data-cell="${dataCellValue}"]`).focus();
        });
    }
}
